import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import {
  BooleanCons, ExcludeDescriptionCatalog, MessageType,
  NumberCons,
  StringConst
} from 'src/app/constants/const';
import { TypeIcon } from 'src/app/model/device/message.model';
import {
  BBVACreateOrderResponse, BBVAOpenPageData,
  BBVAParams, BBVATransactionData
} from 'src/app/model/http/bbva.model';
import { BaseResponseHttp } from 'src/app/model/http/commons.model';
import {
  CallPlaceCompare
} from 'src/app/model/http/myActivity.model';
import { BBVAPaymentsService } from 'src/app/services/bbvapayments.service';
import { DateOperationService } from 'src/app/services/date-operation.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { OrdersService } from 'src/app/services/orders.service';
import { environment } from 'src/environments/environment';
import { BbvaCardsComponent } from '../bbva-cards/bbva-cards.component';
import { NotificationMessageComponent } from '../notification-message/notification-message.component';
import { TypeBBVAPayments } from 'src/app/constants/const';

@Component({
  selector: 'app-bbvaopen-page',
  templateUrl: './bbvaopen-page.component.html',
  styleUrls: ['./bbvaopen-page.component.scss'],
})
export class BBVAOpenPageComponent implements OnInit {
  @ViewChild('formFlap') formFlap: ElementRef = {} as ElementRef;
  hash = StringConst.empty;
  order = StringConst.empty;
  reference = StringConst.empty;
  amount = NumberCons.zero;
  customerName = StringConst.empty;
  successUrl = StringConst.empty;
  failureUrl = StringConst.empty;
  cardCode = StringConst.empty;
  transactionId = StringConst.empty;
  bbvaPostUrl = environment.BVVA.postUrl;
  leaveOk: boolean = BooleanCons.false;
  mpAccount = environment.BVVA.mpAccount;
  dateReference = StringConst.empty;
  promotions = StringConst.empty;
  promotionsMSI = StringConst.empty;
  paymentMethods = StringConst.empty;
  token = StringConst.empty;
  disabledButtons = false;
  includesPaymentCard = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BBVAOpenPageData,
    private encryptionService: EncryptionService,
    private bbvaService: BBVAPaymentsService,
    private matDialogRef: MatDialogRef<BBVAOpenPageComponent>,
    private orderService: OrdersService,
    private dialogservice: DialogService,
    private dateOperationsService: DateOperationService
  ) { }

  ngOnInit(): void {
    this.matDialogRef.disableClose = true;
    this.amount = Number(this.data.amount.toFixed(2));
    this.customerName = this.data.customerName;
    this.cardCode = this.data.cardCode;
    this.successUrl = this.data.successUrl;
    this.failureUrl = this.data.failureUrl;
    this.getParams();
  }

  getParams(): void {
    this.bbvaService.getBBVAParams().subscribe((res) => {
      const response = res.response ?? new BBVAParams();
      this.dateReference = moment(this.dateOperationsService.addDays(new Date(), response.expirationsDays)).format('YYYY/MM/DD');
      this.promotions = response.promotions;
      this.promotionsMSI = response.promotionsMSI;
      this.paymentMethods = response.paymenthMethods;
      this.includesPaymentCard = this.paymentMethods.includes(TypeBBVAPayments.visaMastercard);
      this.callServices();
    }, () => this.matDialogRef.close());
  }

  callServices(): void {
    if (CallPlaceCompare.pendingOrders === this.data.callPlace) {
      this.createOrderPendingOrders();
    }
    if (CallPlaceCompare.confirmOrder === this.data.callPlace) {
      this.createOrderCar();
    }
    if (CallPlaceCompare.invoicesPaid === this.data.callPlace) {
      this.invoicePayment();
    }
    if (CallPlaceCompare.default === this.data.callPlace) {
      const response: BBVATransactionData = {
        ...new BBVATransactionData(),
        ...this.data.default,
      };
      this.resolveBbvaCreateOrder({ code: 200, response });
    }
  }

  createOrderPendingOrders(): void {
    this.orderService.selectMethodToBBVA([this.data.transactionId]).subscribe(() => {
      this.order = this.data.transactionId.slice(-12);
      this.reference = this.data.transactionId.slice(-12);
      this.transactionId = this.data.transactionId;
      this.hashMessage();
    }, this.resolveBbvaCreateOrderError);
  }

  createOrderCar(): void {
    this.bbvaService.createBBVAOrder(this.data.confirmOrder).
      subscribe(this.resolveBbvaCreateOrder, this.resolveBbvaCreateOrderError);
  }

  invoicePayment(): void {
    this.bbvaService
      .createBBVAOrderInvoice(this.data.payInvoice, this.data.isCreateOrder)
      .subscribe(this.resolveBbvaCreateOrder, this.resolveBbvaCreateOrderError);
  }

  close(): void {
    this.bbvaService.cancelTransactions([this.transactionId]).subscribe((res) => {
      this.matDialogRef.close();
    });
  }

  resolveBbvaCreateOrder = (res: BBVACreateOrderResponse) => {
    if (res.code !== 200) {
      this.resolveBbvaCreateOrderError(res);
    }
    this.order = res.response.bbvaOrderId;
    this.reference = res.response.bbvaOrderId;
    this.transactionId = res.response.transactionId;
    this.cardCode = res.response.cardCode;
    this.hashMessage();
  }

  resolveBbvaCreateOrderError = (res: BaseResponseHttp) => {
    this.matDialogRef.close();
    this.dialogservice.openNotificationGeneric(NotificationMessageComponent, {
      isButtonCancel: false,
      textToShow: res.userError,
      typeIcon: TypeIcon.error,
      typeMessage: MessageType.error,
      wasOk: false,
    });
  }

  hashMessage(): void {
    const message = `${this.order}${this.reference}${this.amount}`;
    this.encryptionService.getHashMessage(message).subscribe((res) => {
      this.hash = res.response;
    });
  }
  selectCard(): void {
    this.dialogservice.displayDialog(BbvaCardsComponent, {}).afterClosed().subscribe((res) => {
      if (res) {
        this.token = res === ExcludeDescriptionCatalog.noApplyLabel ? StringConst.empty : res;
        this.disabledButtons = true;
        this.paymentMethods = TypeBBVAPayments.visaMastercard;
        setTimeout(() => {
          this.formFlap.nativeElement.submit();
        }, 1);
      }
    });
  }
}
